// Cierge Labs — Journey Storybook registry.
//
// One entry per illustrative journey. Add a new object to this array to
// surface a new journey on `/journeys`. Keep status labels exactly within the
// existing Cierge Labs taxonomy:
//
//   "Illustrative reference architecture"  — drawn from public descriptions,
//                                             no live integration.
//   "Concept"                               — design-only, not yet built.
//   "Simulation"                            — runs a simulated scenario.
//   "Live KATLAS node"                      — live receipts (e.g. ClubCierge).
//
// No new statuses without explicit approval — the platform-site taxonomy is
// the source of truth and "honesty in status" is part of the brand.

export const JOURNEYS = [
  {
    slug: "governed-agentic-procurement",
    title: "Governed Agentic Procurement",
    subtitle: "An illustrative circular-asset reference journey.",
    summary:
      "How KATLAS complements machine-readable commerce protocols when an AI-assisted purchase has financial, technical, safety, warranty, sustainability or operational consequences.",
    status: "Illustrative reference architecture",
    primarySector: "Supply Chain",
    secondaryTags: ["Circular assets", "Manufacturing", "Procurement"],
    href: "/journeys/governed-agentic-procurement",
  },
];
